<div class="container">
  <go-back-button [url]="GO_TASK_URL"></go-back-button>
  <ng-container *ngIf="(config$ | async) as config">
    <div [ngClass]="[config.localVersion ? 'offline-wrapper' : 'online-wrapper']">
      <white-card>
        <attribute-item *ngFor="let item of customHeaders" [item]="item"></attribute-item>
        <hr class="divider">
        <form-headers [formHeaders]="config.form?.formHeaders" />
        <ng-container *ngIf="pdfFiles && pdfFiles.length">
          <div *ngFor="let pdf of pdfFiles" (click)="openPdf(pdf)" class="pdf-item">
            <b>{{ 'PDF_HEADER' | translate }}: </b>{{ pdf.lineExternalId }} &raquo;
          </div>
          <hr class="divider">
        </ng-container>
        <form *ngIf="config.form" [formGroup]="form" (ngSubmit)="onSubmit()" class="dynamic-form">
          <div *ngFor="let entry of config.form.entries">
            <dynamic-form-item
              [item]="entry"
              [form]="form"
              [defectsNo]="defectsLastNo"
              [task]="config"
              [readonly]="readonly"
              [failureId]="failureId"
              [focusEntryKey]="syncIssueEntryKey"
              [validationRefreshTick]="validationRefreshTick"
              ></dynamic-form-item>
          </div>
          <div *ngIf="showActionButtons" class="form-buttons">
            <button
              *ngIf="showFillInButton"
              mat-button type="button"
              (click)="fillIn()">
              <mat-icon class="material-icons-outlined">fact_check</mat-icon>
              {{ 'FILL_IN' | translate }}
            </button>
            <button
              *ngIf="showSaveButton"
              mat-button
              type="button"
              [disabled]="isAutosaving$ | async"
              (click)="save()">
              <mat-icon [class.rotate]="isAutosaving$ | async">save</mat-icon>
              {{ 'SAVE' | translate }}
            </button>
            <button
              *ngIf="showSubmitButton && !config.localVersion && (connectionStatusService.networkStatus$ | async)"
              mat-button
              [disabled]="isAutosaving$ | async"
              type="submit">
              <mat-icon>send</mat-icon>
              {{ submitLabel | translate }}
            </button>
            <button *ngIf="showCloseButton" mat-button type="button" (click)="close()">
              <mat-icon>close</mat-icon>
              {{ 'CLOSE' | translate }}
            </button>
          </div>
        </form>
      </white-card>
    </div>
  </ng-container>
</div>


